<template>
  <b-modal v-if="users" v-model="active" :title="title" centered size="md" :hide-footer="!footer">
    <h-f-design-search-field
      v-model="searchInput"
      placeholder="Rechercher des utilisateurs"
      style="position: relative; z-index: 1000"
    >
    </h-f-design-search-field>
    <div class="user-container-search">
      <div v-for="(user, index) in users" :key="index" class="d-flex justify-content-between align-items-center mb-2">
        <h-e-profile-default :first-name="user.first_name" :last-name="user.last_name" size="sm"></h-e-profile-default>
        <div>{{ user.first_name }} {{ user.last_name }}</div>
        <i class="mdi mdi-plus-circle-outline text-primary cursor-pointer" @click="addUser(index)"></i>
      </div>
    </div>
    <h5 class="mt-3">Utilisateurs associés :</h5>
    <div class="mt-3 px-4">
      <div
        v-for="(user, index) in assignedUsersObject"
        :key="index"
        class="d-flex justify-content-between align-items-center mb-2"
      >
        <h-e-profile-default :first-name="user.first_name" :last-name="user.last_name" size="sm"></h-e-profile-default>
        <div>{{ user.first_name }} {{ user.last_name }}</div>
        <i class="mdi mdi-close text-primary cursor-pointer" @click="removeUser(user.uuid)"></i>
      </div>
    </div>
    <template #modal-footer>
      <div v-if="loadedPost" class="d-flex justify-content-between w-100">
        <h-b-action text="Annuler" :positive="false" @click.native="active = false"></h-b-action>
        <h-b-action text="Valider" positive @click.native="$emit('clickSubmit')"></h-b-action>
      </div>
      <h-e-spinner v-else size="sm" class="d-flex justify-content-end w-100"></h-e-spinner>
    </template>
  </b-modal>
</template>

<script>
import { Hk } from '@/node-sdk'

const { User } = Hk.App
export default {
  name: 'user-v2',

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Gestion des utilisateurs',
    },
    limitToUsers: {
      type: Array,
      default: () => [],
    },
    assignedUsersObject: {
      type: Array,
      required: true,
    },
    footer: {
      type: Boolean,
      default: false,
    },
    loadedPost: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      users: [],
      active: false,
      userUrl: process.env.VUE_APP_API,
      assignedUsers: this.value,
      assignedUsersObjectData: this.assignedUsersObject,
      searchInput: null,
      loaded: false,
    }
  },

  watch: {
    searchUsers() {
      this.formatSearchUsers()
    },

    value() {
      this.assignedUsers = this.value
    },

    assignedUsersObject() {
      this.assignedUsersObjectData = this.assignedUsersObject
    },

    assignedUsersObjectData() {
      this.$emit('update:assignedUsersObject', this.assignedUsersObjectData)
    },

    assignedUsers() {
      this.$emit('input', this.assignedUsers)
      this.$emit('change')
    },

    active() {
      if (!this.active) {
        this.$emit('close')
      }
    },

    async searchInput() {
      await this.getUsers()
    },
  },

  methods: {
    async manageUserPop() {
      this.loaded = false
      this.active = !this.active
      if (this.active) {
        await this.getUsers()
      }
      this.loaded = true
    },

    async getUsers() {
      ;[this.users] = await User.get({
        params: {
          uuid__in: this.limitToUsers,
          search: this.searchInput,
          fields: ['uuid', 'first_name', 'last_name'],
        },
      })
      this.users = this.users.filter((user) => !this.assignedUsers.includes(user.uuid))
    },

    addUser(index) {
      this.assignedUsers.push(this.users[index].uuid)
      this.assignedUsersObjectData.push(this.users[index])
      this.$emit('add', this.users[index].uuid)
      this.$delete(this.users, index)
    },

    removeUser(id) {
      this.users.push(this.assignedUsersObjectData.find((user) => user.uuid === id))
      this.$delete(
        this.assignedUsers,
        this.assignedUsers.findIndex((user) => user === id),
      )
      this.$emit('delete', id)
      this.$delete(
        this.assignedUsersObjectData,
        this.assignedUsersObjectData.findIndex((user) => user.uuid === id),
      )
    },
  },
}
</script>

<style scoped>
.user-container-search {
  max-height: 200px;
  overflow: scroll;
  padding: 40px 30px 20px 30px;
  transform: translateY(-20px);
  display: block;
  z-index: 500;
  border-radius: 0 0 20px 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>
